import { useState } from 'react';
import {
  emptyTasksText,
  getArchivedTasksDataSource,
  getArchivedTasksOptions,
  prepareTasksData,
  TASK_TABS,
} from './helper';
import { ArchiveDropdown } from 'pages/Workshop/components/ArchiveDropdown';
import { TabLabel } from 'pages/Workshop/components/TabLabel';
import { WorkshopTabsTable } from 'pages/Workshop/components/WorkshopTabsTable';
import { useSelector } from 'react-redux';
import { getFilteredTaskAggregateSelector } from 'store/selectors/taskAggregate';

import styles from './styles.module.scss';
import { TransactionDrawer } from 'pages/Workshop/Transactions/TransactionOverview/components/TransactionDrawer';
import { useManageTasksLists } from './useManageTasksList';
import { FormDetails } from 'pages/Workshop/Forms/components/FormDetails';
import { handleViewForm } from 'utils';
import { WorkshopPageTabs } from 'pages/Workshop/components/WorkshopPageTabs';

export const TaskTabs = (tabProps) => {
  const [archivedValue, setArchivedValue] = useState('');
  const [activeKey, setActiveKey] = useState(TASK_TABS.Overdue);

  const { isPending, fetchAggregateTasks } = tabProps;

  const { tasks } = useSelector(getFilteredTaskAggregateSelector);

  if (isPending) return <></>;

  const dataItems = prepareTasksData({ tasks });

  const { overdue, today, thisWeek, upcoming, archivedTasks } = dataItems;

  const {
    tableProps,
    transactionDrawerProps,
    openTransactionDrawer,
    setOpenTransactionDrawer,
    formProcessDetail,
    setFormProcessDetail,
  } = useManageTasksLists({ ...tabProps, tableClassName: styles.taskTable });

  const archivedDataSource = getArchivedTasksDataSource(archivedValue, archivedTasks);
  const tabItems = [
    {
      key: TASK_TABS.Overdue,
      label: <TabLabel title={'Overdue'} count={overdue.length} />,
      children: (
        <WorkshopTabsTable
          {...tableProps(overdue)}
          dataSource={overdue}
          emptyText={emptyTasksText}
        />
      ),
    },
    {
      key: TASK_TABS.Today,
      label: <TabLabel title={'Today'} count={today.length} />,
      children: (
        <WorkshopTabsTable {...tableProps(today)} dataSource={today} emptyText={emptyTasksText} />
      ),
    },
    {
      key: TASK_TABS.ThisWeek,
      label: <TabLabel title={'This Week'} count={thisWeek.length} />,
      children: (
        <WorkshopTabsTable
          {...tableProps(thisWeek)}
          dataSource={thisWeek}
          emptyText={emptyTasksText}
        />
      ),
    },
    {
      key: TASK_TABS.Upcoming,
      label: <TabLabel title={'Upcoming'} count={upcoming.length} />,
      children: (
        <WorkshopTabsTable
          {...tableProps(upcoming)}
          dataSource={upcoming}
          emptyText={emptyTasksText}
        />
      ),
    },
    {
      key: TASK_TABS.Archive,
      label: (
        <ArchiveDropdown
          archivedValue={archivedValue}
          setArchivedValue={(value) => {
            setArchivedValue(value);
            setActiveKey(TASK_TABS.Archive);
          }}
          archivedData={archivedDataSource}
          dropdownOptions={getArchivedTasksOptions(archivedTasks)}
        />
      ),
      children: archivedValue ? (
        <WorkshopTabsTable
          {...tableProps(archivedDataSource)}
          dataSource={archivedDataSource}
          emptyText={emptyTasksText}
        />
      ) : null,
    },
  ];

  return (
    <div>
      <WorkshopPageTabs
        activeKey={activeKey}
        items={tabItems}
        onChange={(value) => {
          if (archivedValue && value !== TASK_TABS.Archive) {
            setArchivedValue('');
          }

          value !== TASK_TABS.Archive && setActiveKey(value);
        }}
      />

      {openTransactionDrawer && (
        <TransactionDrawer
          openDrawer={openTransactionDrawer}
          setOpenDrawer={setOpenTransactionDrawer}
          {...transactionDrawerProps}
        />
      )}

      {formProcessDetail && (
        <FormDetails
          selectedFormProcess={formProcessDetail}
          onClose={() => setFormProcessDetail(undefined)}
          onHandleViewForm={(url, type) => handleViewForm(history, url, type)}
          refetchForms={fetchAggregateTasks}
        />
      )}
    </div>
  );
};
